import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-chevron-right',
	templateUrl: './icon-chevron-right.component.svg',
})
export class IconChevronRightComponent {}
